import { AuthGuard } from '@AppCore/guard/auth-guard.service';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [

  {
    path: 'auth',
    loadChildren: () =>
      import('./features-modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'checkout',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features-modules/shopping/shopping.module').then(
        (m) => m.ShoppingModule
      ),
  },
     {
    path: '',
    loadChildren: () =>
      import('./features-modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
